var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15 13.9C3.12 8.17 8.58 3.4 10.93 1.61a1.77 1.77 0 0 1 2.14 0c2.35 1.82 7.81 6.65 7.78 12.3 0 4.87-3.97 8.84-8.85 8.84-4.88 0-8.85-3.97-8.85-8.85zm8.69-11.09C10.15 4.1 4.63 8.71 4.66 13.9c0 4.06 3.3 7.35 7.35 7.35s7.35-3.29 7.35-7.34c.03-5.12-5.5-9.79-7.2-11.1a.29.29 0 0 0-.16-.06c-.05 0-.11.02-.16.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22V2c0-.41.34-.75.75-.75s.75.34.75.75v20c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.32 19.29a.744.744 0 0 1 .35-1l7.7-3.74c.37-.18.82-.02 1 .35.18.37.03.82-.35 1l-7.7 3.74c-.1.04-.21.07-.32.07-.28 0-.55-.16-.68-.42zM11.32 14.29a.744.744 0 0 1 .35-1l7.37-3.58c.37-.18.82-.03 1 .35.18.38.03.82-.35 1l-7.37 3.58c-.1.04-.21.07-.32.07-.28 0-.55-.16-.68-.42zM11.32 9.29a.744.744 0 0 1 .35-1l5.03-2.44c.37-.18.82-.02 1 .35.18.37.03.82-.35 1l-5.03 2.44c-.1.04-.21.07-.32.07-.28 0-.55-.16-.68-.42z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBlur);
export default __webpack_public_path__ + "static/media/vuesax-outline-blur.60c64a471306f6c86e639889959acff1.svg";
export { ForwardRef as ReactComponent };